import React from 'react';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t } = useTranslation();

  // Helper to wrap each block separated by "|"
  const renderCapacity = () => {
    const capacityText = t('villa.capacity');
    return capacityText.split('|').map((block, idx) => (
      <span key={idx} style={{ margin: '0 4px' }}>{block.trim()}</span>
    ));
  };

  return (
    <header style={{ padding: '20px', background: 'linear-gradient(180deg, #fdfaf4 0%, #f5ece0 100%)', borderBottom: '1px solid rgba(212, 180, 131, 0.35)', boxShadow: '0 2px 14px rgba(70, 123, 145, 0.08)' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <a href="/" style={{ textDecoration: 'none', color: 'inherit', marginRight: '20px' }}>
          <img
            src="/images/logo.png"
            alt={t('header.logoAlt', { defaultValue: 'Villa Pina e Paolo logo' })}
            style={{ height: '150px', marginBottom: '0' }}
          />
        </a>
        <div>
          <h1 style={{ textAlign: 'center' }}>{t('header.title')}</h1>
          <p className='headerSub' style={{ textAlign: 'center' }}>{t('header.subtitle')}
            <br /> <span style={{ color: '#000' }}>+39 376 282 4580</span>
          </p>
        </div>
      </div>
      <p className='capacity' style={{ textAlign: 'center' }}>
        {renderCapacity()}
      </p>
    </header>
  );
};

export default Header;
